var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column"},[_c('app-detail-header',{attrs:{"title":'Usage Reports'}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-4 col-md-6 col-sm-12"},[_c('appFilter')],1),_vm._v(" "),_c('div',{staticClass:"col-lg-8 col-md-6 col-sm-12"},[_c('appResult')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/views/usage/UsageReport.vue